import React, { useState, useEffect } from 'react';
import './EmployeeFormModal.css';

const EmployeeFormModal = ({ isOpen, onClose, onSave, employee = null }) => {
    const [formData, setFormData] = useState({
        id: '',
        name: '',
        email: '',
        pin: '',
        department: '',
        role: 'Sales'
    });

    useEffect(() => {
        if (employee) {
            setFormData({
                id: employee.id || '',
                name: employee.name || '',
                email: employee.email || '',
                pin: '',
                department: employee.department || '',
                role: employee.role || 'Sales'
            });
        } else {
            setFormData({
                id: '',
                name: '',
                email: '',
                pin: '',
                department: '',
                role: 'Sales'
            });
        }
    }, [employee, isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <div className="employee-modal-overlay" onClick={onClose}>
            <div className="employee-modal-content" onClick={(e) => e.stopPropagation()}>
                <h3 className="employee-modal-title">{employee ? 'Edit User' : 'Create New User'}</h3>
                <form className="employee-form" onSubmit={handleSubmit}>
                    {!employee && (
                        <div className="form-group">
                            <label>Employee ID (Homebase ID)</label>
                            <input
                                type="text"
                                name="id"
                                value={formData.id}
                                onChange={handleChange}
                                placeholder="e.g. 123456"
                                required
                            />
                        </div>
                    )}
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Full Name"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="email@example.com"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>{employee ? 'PIN (optional - keep blank to retain current)' : 'PIN'}</label>
                        <input
                            type="text"
                            name="pin"
                            value={formData.pin}
                            onChange={handleChange}
                            placeholder={employee ? "Enter new PIN only if changing" : "4-6 digit PIN"}
                            required={!employee}
                        />
                    </div>
                    <div className="form-group">
                        <label>Department</label>
                        <input
                            type="text"
                            name="department"
                            value={formData.department}
                            onChange={handleChange}
                            placeholder="e.g. Sales, Management"
                        />
                    </div>
                    <div className="form-group">
                        <label>Role</label>
                        <select name="role" value={formData.role} onChange={handleChange}>
                            <option value="Sales">Sales</option>
                            <option value="Ecom">Ecom</option>
                            <option value="Admin">Admin</option>
                        </select>
                    </div>

                    <div className="employee-modal-actions">
                        <button type="button" className="employee-btn-cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="employee-btn-save">
                            {employee ? 'Save Changes' : 'Create User'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EmployeeFormModal;
